<div class="container-group" *ngIf="shipmentsInRoute">
    <div class="title">
        {{'SHARED.ROUTE.SHIPMENT.ORDER.TITLE' | translate}}
    </div>

    <button-link variant="forward" class="line right" *ngIf="!readonly && !onlyvieworder && !showvieworder"
        (linkClick)="showvieworder=true">{{
        'SHIPMENT.ACTIONS.SHOWVIEWORDER.CAPTION' | translate}}</button-link>
    <button-link variant="forward" class="line right" *ngIf="!readonly && !onlyvieworder && showvieworder"
        (linkClick)="showvieworder=false">{{
        'SHIPMENT.ACTIONS.HIDEVIEWORDER.CAPTION' | translate}}</button-link>

    <div class="linia bar baroptions" *ngIf="!readonly && !onlyvieworder && !showvieworder">
        <options class="slim mixed-text-icon" [optionstrip]="optionsOrder" (clickOption)="onClickOptionOrder($event)">
        </options>
    </div>
    <div class="list">

        <div cdkDropList (cdkDropListDropped)="drop($event)"
            [cdkDropListDisabled]="readonly || (!onlyvieworder && !showvieworder)">
            <div class="item-container" [ngClass]="{'draggable': !readonly && (onlyvieworder || showvieworder)}"
                *ngFor="let item of shipmentsInRoute | sortBy:getOrder()" cdkDrag
                [cdkDragDisabled]="readonly || (!onlyvieworder && !showvieworder)">

                <shared-shipment-item class="shipmentItem nogeneralstatus simple" [shipment]="item"
                    [isActiveRoutes]="'true'" (click)="selectShipment(item)"
                    [ngClass]="{'selected': selectedShipment!=null && item.shipmentId==selectedShipment.shipmentId}">
                </shared-shipment-item>

                <div class="buttons" *ngIf="!readonly && (showvieworder || onlyvieworder)">
                    <button class="move-shipment move-up" (click)="moveShipmentUp(item)">
                        <i class="fa fa-chevron-up"></i>
                        <span>
                            {{ "SHIPMENT.ACTIONS.MOVEUP.SLIM" | translate }}
                        </span>
                    </button>
                    <button class="move-shipment move-down" (click)="moveShipmentDown(item)">
                        <i class="fa fa-chevron-down"></i>
                        <span>
                            {{ "SHIPMENT.ACTIONS.MOVEDOWN.SLIM" | translate }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>